<app-slide
  [mechanicalDisplacement]="!isMobile"
  [activated]="!!stores?.length"
  [quantityOfItems]="stores?.length"
  [slideWidth]="slideWidth">
    <ng-container *ngFor="let store of stores; index as id">
      <div class="slideStore__content" [style.width]="slideWidth + 'px'">
        <app-ds-generic-card
          [space]="genericCardSpaces.Nano">
          <div
            #slideStore
            class="slideStore__item"
            [id]="'slide-store-item-' + index + '-' + id"
            (click)="selectStore(store)">
            <div class="slideStore__image">
              <app-image 
                [type]="typeImageFlight" 
                [src]="store | imageDesktopOrMobile | async" 
                [borderRadius]="8">
              </app-image>
            </div>
            <div class="slideStore__text">
              <app-ds-typography
                [size]="isMobile ? fontSize.XXXS : fontSize.XXS"
                [fontFamily]="fontFamily.Regular"
                [color]="fontColor.Primary"
                [text]="store.title"
                [ellipsis]="false">
              </app-ds-typography>
            </div>
          </div>
        </app-ds-generic-card>
      </div>
    </ng-container>
</app-slide>
